import { render, staticRenderFns } from "./Suggestion.vue?vue&type=template&id=7671a82d&scoped=true"
import script from "./Suggestion.vue?vue&type=script&lang=js"
export * from "./Suggestion.vue?vue&type=script&lang=js"
import style0 from "./Suggestion.vue?vue&type=style&index=0&id=7671a82d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671a82d",
  null
  
)

export default component.exports